<template>
  <div class="page_main">
    <div class="page_title">
      <span>
        <span class="back_home" @click="bank_home">
          <Icon type="md-arrow-back" />返回项目详情页 &nbsp;|
        </span>
        发布招聘海报
      </span>

      <div></div>
    </div>
    <div class="card_main">
      <div
        class="upload_card"
        v-for="(item, i) in poster_list"
        :key="i"
        @click="click_view_img(item)"
      >
        <img :src="item.img_url" alt="" style="width: 100%; height: 100%" />
        <div class="img_options" @click.stop="poster_del(item.poster_id)">
          <Icon type="md-close" size="14" color="#fff" />
        </div>
      </div>

      <div class="upload_card">
        <Upload
          :action="upload_url"
          :show-upload-list="false"
          :on-success="upload_success"
        >
          <Button type="primary">+上传海报模板</Button>
        </Upload>
      </div>
    </div>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  data() {
    return {
      project_id: "",
      upload_url: "",
      img_url: "",
      img_object_name: "",
      poster_list: [],
    };
  },
  mounted() {
    var query = this.$route.query;
    this.project_id = query.project_id;
    this.upload_url =
      process.env.VUE_APP_HOST +
      "/tools/poster/upload_template?token=" +
      this.$cookies.get("dx_token") +
      "&project_id=" +
      this.project_id;

    this.get_poster_list();
  },
  methods: {
    //海报列表
    get_poster_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http("post", process.env.VUE_APP_HOST + "/tools/poster/poster_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.poster_list = res.data.poster_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    poster_del(poster_id) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在删除海报模板，是否继续？</p>",
        onOk: () => {
          that.poster_del_http(poster_id);
        },
        onCancel: () => {},
      });
    },

    //海报删除
    poster_del_http(poster_id) {
      var that = this;
      var obj = {
        poster_id: poster_id,
      };
      http("post", process.env.VUE_APP_HOST + "/tools/poster/poster_del", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_poster_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    upload_success(e) {
      console.log(e);
      if (e.code == 0) {
        this.$Message.success(e.msg);
        this.img_url = e.data.url;
        this.img_object_name = e.data.img_object_name;
        this.get_poster_list();
      } else {
        this.$Message.error(e.msg);
      }
    },

    bank_home() {
      this.$router.push({
        path: "/workbench/project_detail",
        query: {
          project_id: this.project_id,
        },
      });
    },

    click_view_img(item) {
      this.$ImagePreview.show({
        previewList: [item.img_url],
      });
    },
  },
};
</script>

<style scoped>
.img_options {
  width: 20px;
  height: 20px;
  background: red;
  border: 1px solid white;
  position: absolute;
  display: flex;
  padding-right: 2px;
  align-items: center;
  top: 0;
  right: 1px;
}

.page_main {
  background: #ececec;
  min-height: 100vh;
  overflow: auto;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
}

.img_options {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.upload_card {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  width: 140px;
  height: 200px;
  border: 1px solid #ccc;
  margin: 10px 10px 0 10px;
  line-height: 200px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  justify-content: center;
}

.upload_card:hover {
  border: 2px dashed #0073ff;
  box-shadow: 0 0 5px #ccc;
}

.back_home {
  color: #e2e9f1;
  cursor: pointer;
  margin-right: 10px;
}

.back_home:hover {
  color: #fff;
}
.page_title {
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 3px;
  padding: 0 15px 0 15px;
  background-color: #0466dd;
  color: #fff;
  height: 40px;
  line-height: 40px;
}
</style>
